module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kbx-trigger-content"
  }, [(_vm.boxConfig.trigger_button.kind === 'naked') ? _c('input', {
    staticClass: "kbx-trigger-btn naked",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.boxConfig.trigger_button.text
    },
    on: {
      "change": function($event) {
        return _vm.boxUpdateConfig({
          item: 'trigger_button',
          key: 'text',
          value: $event.target.value
        })
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-62bfeeee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/triggerbutton/Naked.vue
 ** module id = 847
 ** module chunks = 1
 **/